export default "__VITE_ASSET__77504b5a__"